import React, { useState, useEffect } from 'react'
import { Button, CircularProgress, IconButton, Paper, Stack, Typography } from '@mui/material'
import useOtp from '../hooks/useOtp'
import OtpInput from 'react-otp-input'
import { useAuth } from '../../../providers/AuthProvider/AuthProvider'
import useLogin from '../../Login/hooks/useLogin'
import { ArrowRightAlt } from '@mui/icons-material'
import { ArrowBack } from '@material-ui/icons'
import { useNavigate } from 'react-router-dom'
import { useMobile } from '../../../hooks/useMoblie'

const timerDuration = 30

function OTPVerificationForm() {
    const { status, error, otp, handleOTPSubmit, handleChange, setOtp } = useOtp()
    const { handlePhoneNumberSubmit } = useLogin()
    const { phoneNumber } = useAuth()
    const [resendOTP, setResendOTP] = useState(false)
    const [timer, setTimer] = useState(timerDuration)

    const onResendOtpClicked = () => {
        handlePhoneNumberSubmit()
        setResendOTP(false)
        setTimer(timerDuration)
        setOtp({ otp: '' })
    }

    useEffect(() => {
        let t
        if (timer === 0) {
            setResendOTP(true)
        }
        if (timer > 0) {
            t = setTimeout(() => setTimer((prev) => prev - 1), 1000)
        }
        return () => clearTimeout(t)
    }, [timer, setTimer])
    const navigate = useNavigate()
    const isMobile = useMobile()
    return (
        <Paper
            sx={{
                width: isMobile ? 350 : 400,
                height: isMobile ? 350 : 400,
                p: 4,
                borderRadius: 8,
            }}
        >
            {' '}
            <IconButton
                sx={{
                    p: 0,
                }}
                onClick={() => {
                    navigate('/login')
                }}
            >
                <ArrowBack />
            </IconButton>
            <Typography variant="h5" component="h1">
                Enter OTP
            </Typography>
            {/* <Typography variant="caption" component="p" color="textSecondary">
                Enter OTP to continue
            </Typography> */}
            <Typography variant="body2">OTP sent to: {phoneNumber}</Typography>
            <OtpInput
                value={otp.otp}
                onChange={handleChange}
                numInputs={6}
                shouldAutoFocus
                isInputNum
                separator={<span> </span>}
                hasErrored={error ? true : false}
                inputStyle={{
                    height: '2rem',
                    margin: '1rem 0.25rem',
                    display: 'flex',
                    gap: '0.5rem',
                    width: '100%',
                    fontSize: '1.25rem',
                    borderRadius: 4,
                    border: '1px solid rgba(0,0,0,0.3)',
                }}
            />
            {error && <Typography>{error}</Typography>}
            <Button
                sx={{
                    mt: 1,
                    height: 48,
                }}
                onClick={handleOTPSubmit}
                variant="contained"
                color="primary"
                fullWidth
                endIcon={status !== 'loading' && <ArrowRightAlt />}
                disabled={status === 'loading'}
            >
                {status === 'loading' ? <CircularProgress size={30} /> : `Enter OTP`}
            </Button>
            {/* <Typography className={classes.resendOTP}>
        Resend OTP in <span style={{ fontWeight: "bold" }}>{timer}s </span>
      </Typography> */}
            <Stack
                direction="row"
                justifyContent="center"
                sx={{
                    mt: 3,
                }}
            >
                <Button
                    sx={{
                        height: 48,
                    }}
                    variant="outlined"
                    disabled={resendOTP ? false : true}
                    color="primary"
                    size="small"
                    onClick={onResendOtpClicked}
                >
                    Resend OTP <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>{timer}s </span>
                </Button>
            </Stack>
        </Paper>
    )
}

export default OTPVerificationForm
